var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    fill: "none",
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 1.429c-4.644 0-8.572 2.611-8.572 5.714 0 1.663 1.116 3.248 3.047 4.341l.97.558-.3 1.072a8.066 8.066 0 0 1-.782 1.92 11.056 11.056 0 0 0 3.07-1.909l.48-.424.636.067c.48.056.97.09 1.45.09 4.643 0 8.572-2.612 8.572-5.715 0-3.103-3.929-5.714-8.572-5.714Zm10 5.714c0 3.95-4.476 7.143-10 7.143-.548 0-1.094-.034-1.62-.09a12.234 12.234 0 0 1-5.133 2.701c-.401.112-.837.19-1.272.246h-.056c-.223 0-.424-.179-.48-.424v-.012c-.055-.28.134-.446.302-.647.703-.792 1.506-1.462 2.031-3.326C1.472 11.43 0 9.41 0 7.143 0 3.193 4.476 0 10 0s10 3.192 10 7.143Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.40047982.svg";
export { ForwardRef as ReactComponent };